import { render, staticRenderFns } from "./StudentCourse.vue?vue&type=template&id=e9167ac4&scoped=true&"
import script from "./StudentCourse.vue?vue&type=script&lang=js&"
export * from "./StudentCourse.vue?vue&type=script&lang=js&"
import style0 from "./StudentCourse.vue?vue&type=style&index=0&id=e9167ac4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9167ac4",
  null
  
)

export default component.exports